import React from "react";
import PropTypes from "prop-types";
import { Badge, withStyles } from "@material-ui/core";
import ButtonLink from "../../../../_common/components/ButtonLink";
import permissions from "../../../../_common/permissions";
import { useSelectPermission } from "../../../../hooks";
import { ACCESS_LEVEL } from "../../../../_common/constantes";

function ButtonFeedbackLigacao({ label, qtdNaoLidos, classes, ...props }) {
  const abrirAudiosPermission = useSelectPermission(permissions.ABRIR_AUDIO_DAS_LIGACOES);
  if (abrirAudiosPermission && abrirAudiosPermission.nivelAcesso === ACCESS_LEVEL.NONE) return null;

  return (
    <ButtonLink variant="caption" {...props}>
      {label}
      {qtdNaoLidos > 0 && (
        <Badge
          classes={{
            root: classes.badgeRoot,
            badge: classes.badge,
          }}
          badgeContent={qtdNaoLidos}
          color="primary"
        />
      )}
    </ButtonLink>
  );
}

ButtonFeedbackLigacao.propTypes = {
  label: PropTypes.string,
  qtdNaoLidos: PropTypes.number,
};

export default withStyles({
  badgeRoot: {
    marginLeft: 8,
  },
  badge: {
    fontSize: 10,
    /**
     * sem configurar esses atributos,
     * a Badge tenta se posicionar no topo a direita
     */
    position: "initial",
    transform: "none",
  },
})(ButtonFeedbackLigacao);
